import { useMemo, useRef } from "react";
import selectDisplayedRulebookSnapshot from "./selectDisplayedRulebookSnapshot";
/** Sentinel `messageId` of the turn-0 snapshot: it is not attached to any persisted message. */
export const INITIAL_SNAPSHOT_MESSAGE_ID = "";
function toInitialSnapshot(initialState) {
    if (!initialState) {
        return null;
    }
    return { meta: initialState, messageId: INITIAL_SNAPSHOT_MESSAGE_ID, isPastState: false };
}
export default function useDisplayedRulebookSnapshot({ conversation, altMsgs, altMsgPosition, initialState = null, rulebookId, isEnabled = true, isConversationLoaded, }) {
    // Keep the returned object reference stable across re-renders (e.g. message streaming)
    // so HUD descendants wrapped in React.memo do not re-render on every appended chunk.
    const refPrevious = useRef(null);
    return useMemo(() => {
        if (!isEnabled) {
            return null;
        }
        // An empty conversation means messages are still loading (a loaded thread always has the greeting):
        // do not flash the turn-0 defaults before the real snapshot arrives.
        const hasLoadedMessages = isConversationLoaded ?? conversation.length > 0;
        const next = selectDisplayedRulebookSnapshot({ conversation, altMsgs, altMsgPosition, rulebookId }) ??
            (hasLoadedMessages ? toInitialSnapshot(initialState) : null);
        const previous = refPrevious.current;
        if (previous && next && previous.messageId === next.messageId && previous.meta === next.meta && previous.isPastState === next.isPastState) {
            return previous;
        }
        refPrevious.current = next;
        return next;
    }, [conversation, altMsgs, altMsgPosition, initialState, rulebookId, isEnabled, isConversationLoaded]);
}
